import {ApplicationIds, IAppConfig} from 'ngx-heka-design-lib';

export interface IAppExtendedConfig extends IAppConfig{
  translationContent?: string;
  showAsWidget?: boolean;
}

export const APP_CONFIGS: IAppExtendedConfig[] = [
  {
    appId: ApplicationIds.CUSTOMER_PORTAL,
    translationTitle: 'APPS.CUSTOMER_PORTAL.TITLE',
    isCurrentApp: true,
    order: 0,
    imgUrl: 'assets/images/heka-logo-symbols/hplus.svg',
    translationContent: 'APPS.CUSTOMER_PORTAL.DESCRIPTION',
    showAsWidget: false,
  },
  {
    appId: ApplicationIds.HPLUS_SERVICE,
    translationTitle: 'APPS.SERVICE.TITLE',
    isCurrentApp: false,
    order: 1,
    imgUrl: 'assets/images/heka-logo-symbols/office.svg',
    translationContent: 'APPS.SERVICE.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.B2B_ONLINE,
    translationTitle: 'APPS.B2B_ONLINE.TITLE',
    isCurrentApp: false,
    order: 2,
    imgUrl: 'assets/images/heka-logo-symbols/b2b_online.svg',
    translationContent: 'APPS.B2B_ONLINE.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.OPERATOR,
    translationTitle: 'APPS.OPERATOR.TITLE',
    isCurrentApp: false,
    order: 3,
    imgUrl: 'assets/images/heka-logo-symbols/operator.svg',
    translationContent: 'APPS.OPERATOR.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.ELECTRICITY_CALCULATION_TOOL,
    translationTitle: 'APPS.ELECTRICITY_CALCULATION_TOOL.TITLE',
    isCurrentApp: false,
    order: 4,
    imgUrl: 'assets/images/heka-logo-symbols/e_calc_tool.svg',
    translationContent: 'APPS.ELECTRICITY_CALCULATION_TOOL.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.TENDER_TOOL,
    translationTitle: 'APPS.TENDER_TOOL.TITLE',
    isCurrentApp: false,
    order: 5,
    imgUrl: 'assets/images/heka-logo-symbols/tender_tool.svg',
    translationContent: 'APPS.TENDER_TOOL.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.LEVEL_2,
    translationTitle: 'APPS.LEVEL_2.TITLE',
    isCurrentApp: false,
    order: 6,
    imgUrl: 'assets/images/heka-logo-symbols/hplus.svg',
    translationContent: 'APPS.LEVEL_2.DESCRIPTION',
    showAsWidget: false,
  },
  {
    appId: ApplicationIds.HPLUS_DONGLE,
    translationTitle: 'APPS.HPLUS_DONGLE.TITLE',
    isCurrentApp: false,
    order: 7,
    imgUrl: 'assets/images/heka-logo-symbols/dongle.svg',
    translationContent: 'APPS.HPLUS_DONGLE.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.HPLUS_DONGLE_ADMIN,
    translationTitle: 'APPS.HPLUS_DONGLE_ADMIN.TITLE',
    translationContent: 'APPS.HPLUS_DONGLE_ADMIN.DESCRIPTION',
    isCurrentApp: false,
    order: 8,
    imgUrl: 'assets/images/heka-logo-symbols/dongle_admin.svg',
    showAsWidget: false
  },
  {
    appId: ApplicationIds.REMOTE_ADMIN,
    translationTitle: 'APPS.REMOTE_ADMIN.TITLE',
    isCurrentApp: false,
    order: 9,
    imgUrl: 'assets/images/heka-logo-symbols/remote_desktop.svg',
    translationContent: 'APPS.REMOTE_ADMIN.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.REMOTE_DESKTOP,
    translationTitle: 'APPS.REMOTE_DESKTOP.TITLE',
    isCurrentApp: false,
    order: 10,
    imgUrl: 'assets/images/heka-logo-symbols/remote_desktop.svg',
    translationContent: 'APPS.REMOTE_DESKTOP.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.OMS_TOOL,
    translationTitle: 'APPS.OMS_TOOL.TITLE',
    isCurrentApp: false,
    order: 11,
    imgUrl: 'assets/images/heka-logo-symbols/oms.svg',
    translationContent: 'APPS.OMS_TOOL.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.STATUS,
    translationTitle: 'APPS.STATUS.TITLE',
    isCurrentApp: false,
    order: 12,
    imgUrl: 'assets/images/heka-logo-symbols/status.svg',
    translationContent: 'APPS.STATUS.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.GO_APP_ADMIN,
    translationTitle: 'APPS.GO_APP_ADMIN.TITLE',
    isCurrentApp: false,
    order: 13,
    imgUrl: 'assets/images/heka-logo-symbols/go_app.svg',
    translationContent: 'APPS.GO_APP_ADMIN.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.LEARN_WORLD,
    translationTitle: 'APPS.LEARN_WORLD.TITLE',
    isCurrentApp: false,
    order: 14,
    imgUrl: 'assets/images/heka-logo-symbols/learn_world.svg',
    translationContent: 'APPS.LEARN_WORLD.DESCRIPTION',
    showAsWidget: true,
  },
  {
    appId: ApplicationIds.AI_PLAN,
    translationTitle: 'APPS.AI_PLAN.TITLE',
    isCurrentApp: false,
    order: 15,
    imgUrl: 'assets/images/heka-logo-symbols/ai_plan.svg',
    translationContent: 'APPS.AI_PLAN.DESCRIPTION',
    showAsWidget: true,
  }
];

export class AppExtendedActionItem {
  config: IAppExtendedConfig;
  clickHandler: Function = () => {};

  constructor(config: IAppExtendedConfig) {
    this.config = config;
  }

  onClick() {
    this.clickHandler();
  }
}
